import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { AntragsType } from '@ebeihilfe/core';
import { KurzantragConfig } from '@ebeihilfe/einreichung-old';
import { LegacyFeldTyp } from '@eBeihilfe/einreichung-shared/enums';
import { RadioElement } from '@ebeihilfe/forms';

export const getKurzantragConfig = (): KurzantragConfig => {
  return {
    formlyConfig: [
      new RadioElement({
        key: 'antragsArt',
        required: true,
        options: [
          {
            label: _('kurzantrag.antrags_art.kurzantrag'),
            value: AntragsType.KURZANTRAG,
            key: AntragsType[AntragsType.KURZANTRAG],
          },
          {
            label: _('kurzantrag.antrags_art.langantrag'),
            value: AntragsType.LANGANTRAG_LEGACY,
            key: AntragsType[AntragsType.LANGANTRAG],
          },
        ],
      }),
    ],
    meta: [
      {
        keyDom: '', // todo delete here and in backend
        keyInternal: 'antragsArt',
        type: LegacyFeldTyp.TEXT,
        valueFromForm: (model) => model['antragsArt'],
      },
    ],
  };
};
